import { render, staticRenderFns } from "./RoomParticipate.vue?vue&type=template&id=52598bcc&scoped=true&"
import script from "./RoomParticipate.vue?vue&type=script&lang=ts&"
export * from "./RoomParticipate.vue?vue&type=script&lang=ts&"
import style0 from "./RoomParticipate.vue?vue&type=style&index=0&id=52598bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52598bcc",
  null
  
)

export default component.exports